import React from 'react';
import { Box, Divider, Switch, Typography } from '@mui/material';

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  description?: string;
};

/** Toggle mestre «Todas» — lista vazia = sem filtro (dashboard / preferências). */
export function TodasMasterSwitch({
  checked,
  onChange,
  label = 'Todas',
  description = 'Sem filtro — considera todos os itens',
}: Props) {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 2,
          py: 1.25,
          bgcolor: checked ? 'action.selected' : 'transparent',
          borderRadius: 1,
        }}
      >
        <Box>
          <Typography variant="body2" fontWeight={checked ? 700 : 500}>
            {label}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {description}
          </Typography>
        </Box>
        <Switch checked={checked} onChange={(_, v) => onChange(Boolean(v))} color="success" />
      </Box>
      <Divider />
    </>
  );
}
